import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined';
import LaptopMacOutlinedIcon from '@mui/icons-material/LaptopMacOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import NotificationImportantOutlinedIcon from '@mui/icons-material/NotificationImportantOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import type { AppModule } from './types';

/**
 * Static registry of all navigation modules and their routes for the
 * management SPA. Order here determines the order rendered in navigation.
 * Actual visibility is further filtered by role/access checks (see
 * {@link ModuleNavigation}); this registry alone does not enforce authorization.
 */
export const moduleRegistry: AppModule[] = [
  {
    id: 'assets',
    labelKey: 'modules.assets',
    icon: <DevicesOtherOutlinedIcon />,
    routes: [
      {
        labelKey: 'modules.allAssets',
        path: '/assets',
        icon: <LaptopMacOutlinedIcon />,
        children: [
          {
            labelKey: 'modules.spareAssets',
            path: '/assets/spares',
            icon: <Inventory2Icon />,
          },
          {
            labelKey: 'modules.endOfLease',
            path: '/assets/end-of-lease',
            icon: <EventBusyIcon />,
          },
        ],
      },
      {
        labelKey: 'modules.changeHistory',
        path: '/assets/history',
        icon: <ManageHistoryOutlinedIcon />,
      },
    ],
  },
  {
    id: 'notifications',
    labelKey: 'modules.notifications',
    icon: <NotificationsOutlinedIcon />,
    routes: [
      {
        labelKey: 'modules.notificationCenter',
        path: '/notifications',
        icon: <NotificationsActiveOutlinedIcon />,
      },
    ],
  },
  {
    id: 'contracts',
    labelKey: 'modules.contracts',
    icon: <HandshakeOutlinedIcon />,
    routes: [
      {
        labelKey: 'modules.contractsDashboard',
        path: '/contracts/dashboard',
        icon: <SpaceDashboardOutlinedIcon />,
      },
      {
        labelKey: 'modules.contractsAll',
        path: '/contracts/all',
        icon: <ArticleOutlinedIcon />,
        children: [
          {
            labelKey: 'modules.contractsEndingSoon',
            path: '/contracts/ending-soon',
            icon: <HourglassBottomOutlinedIcon />,
          },
          {
            labelKey: 'modules.contractsNoticeLead',
            path: '/contracts/notice-lead',
            icon: <NotificationImportantOutlinedIcon />,
          },
          {
            labelKey: 'modules.contractDocumentsSearch',
            path: '/contracts/documents',
            icon: <FindInPageOutlinedIcon />,
          },
        ],
      },
      {
        labelKey: 'modules.changeHistory',
        path: '/contracts/history',
        icon: <ManageHistoryOutlinedIcon />,
      },
    ],
  },
  {
    id: 'mobility',
    labelKey: 'modules.mobility',
    icon: <DirectionsCarFilledOutlinedIcon />,
    routes: [
      {
        labelKey: 'modules.mobilityAccounts',
        path: '/mobility/accounts',
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      {
        labelKey: 'modules.mobilityClaims',
        path: '/mobility/claims',
        icon: <ReceiptLongOutlinedIcon />,
      },
      {
        labelKey: 'modules.mobilityPayroll',
        path: '/mobility/payroll',
        icon: <PaymentsOutlinedIcon />,
      },
      {
        labelKey: 'modules.changeHistory',
        path: '/mobility/history',
        icon: <ManageHistoryOutlinedIcon />,
      },
    ],
  },
];
